module.exports = __webpack_public_path__ + "905d991ff33a8e710028a87508a4efc6.png";


//////////////////
// WEBPACK FOOTER
// ./images/vipcz/Vrinda.png
// module id = 579
// module chunks = 30